import { render, staticRenderFns } from "./tab-skill.vue?vue&type=template&id=6e62364a&scoped=true"
import script from "./tab-skill.vue?vue&type=script&lang=js"
export * from "./tab-skill.vue?vue&type=script&lang=js"
import style0 from "./tab-skill.vue?vue&type=style&index=0&id=6e62364a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e62364a",
  null
  
)

export default component.exports